<script>
export default {
  data() {
    return {
      value: null,
      value1: null,
      value2: null,
      value3: null,
      value4: null,
      value5: null,
      value6: null,
      value7: null,
      value8: null,
      value9: null,
      value10: null,
      isPasswordVisible: false,
      currentStep: 0,
      SelcDura: ["Select", "1 Hr", "2 Hr"],
      Slotsecl: ["Select", "2", "3"],
      InterSelc: ["Select", "15 Mins", "30 Mins"],
      SelcDuraOne: ["Select", "1 Hr", "2 Hr"],
      SlotseclOne: ["Select", "2", "3"],
      InterSelcOne: ["Select", "15 Mins", "30 Mins"],
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
    nextStep() {
      if (this.currentStep < 2) {
        this.currentStep++;
      }
    },
    prevStep() {
      if (this.currentStep > 0) {
        this.currentStep--;
      }
    },
    submitForm() {
      this.$router.push("/provider/staff-details");
    },
  },
};
</script>
<style>
/* Optional: Add styles to the fieldsets if needed */
fieldset {
  display: flex; /* Ensure fieldsets are flex containers */
  flex-direction: column; /* Stack children vertically */
}
</style>
<template>
  <!-- Edit Availability -->
  <div class="modal fade custom-modal" id="edit-availability">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content doctor-profile">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Update Availability</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <div class="modal-body">
          <form action="#">
            <div class="modal-wizard">
              <ul class="d-flex align-items-center mb-3" id="progress-list">
                <li
                  class="d-flex align-items-center me-3"
                  :class="{ active: currentStep === 0 }"
                >
                  <span><i class="feather-calendar me-2"></i></span>
                  <p class="fs-14 fw-medium">Add Days</p>
                </li>
                <li
                  class="d-flex align-items-center me-3"
                  :class="{ active: currentStep === 1 }"
                >
                  <span><i class="ti ti-calendar-filled me-2"></i></span>
                  <p class="fs-14 fw-medium">Breaks</p>
                </li>
                <li
                  class="d-flex align-items-center"
                  :class="{ active: currentStep === 2 }"
                >
                  <span><i class="ti ti-clock-off me-2"></i></span>
                  <p class="fs-14 fw-medium">Unavailable Days</p>
                </li>
              </ul>
            </div>
            <div class="available-slot-details">
              <fieldset
                v-if="currentStep === 0"
                :style="{ display: currentStep === 0 ? 'flex' : 'none' }"
              >
                <div class="accordion" id="availability_accordion">
                  <div>
                    <div class="card shadow-none rounded">
                      <div class="card-body">
                        <div class="accordion-item">
                          <div class="accordion-header" id="accordion-headingOne">
                            <div
                              class="accordion-button p-0 border-bottom pb-3"
                              data-bs-toggle="collapse"
                              data-bs-target="#accordion-collapseOne"
                              aria-expanded="true"
                              aria-controls="accordion-collapseOne"
                            >
                              <h6 class="fs-16 fw-medium ms-4">Monday</h6>
                              <div class="form-check form-switch ms-auto">
                                <input class="form-check-input" type="checkbox" />
                              </div>
                            </div>
                          </div>
                          <div
                            id="accordion-collapseOne"
                            class="accordion-collapse collapse show"
                            aria-labelledby="accordion-headingOne"
                            data-bs-parent="#availability_accordion"
                          >
                            <div class="accordion-body border-0 p-0 mt-3">
                              <div class="row gx-3">
                                <div class="col-md-6 col-lg">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Start Time
                                      <span class="text-danger">*</span></label
                                    >
                                    <div class="input-icon position-relative">
                                      <span class="input-icon-addon"
                                        ><i class="ti ti-clock"></i
                                      ></span>
                                      <a-time-picker
                                      v-model:value="value"
                                        class="form-control timepicker"
                                        placeholder="Choose"
                                        use12-hours
                                        format="h:mm a"
                                        type="text"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6 col-lg">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >End Time <span class="text-danger">*</span></label
                                    >
                                    <div class="input-icon position-relative">
                                      <span class="input-icon-addon"
                                        ><i class="ti ti-clock"></i
                                      ></span>
                                      <a-time-picker
                                        v-model:value="value1"
                                        class="form-control timepicker"
                                        placeholder="Choose"
                                        use12-hours
                                        format="h:mm a"
                                        type="text"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6 col-lg">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Duration <span class="text-danger">*</span></label
                                    >
                                    <vue-select
                                      :options="SelcDura"
                                      id="selcdura"
                                      placeholder="Select"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-6 col-lg">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >No of Slots
                                      <span class="text-danger">*</span></label
                                    >
                                    <vue-select
                                      :options="Slotsecl"
                                      id="slotsecl"
                                      placeholder="Select"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-6 col-lg">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Interval Duration
                                      <span class="text-danger">*</span></label
                                    >
                                    <vue-select
                                      :options="InterSelc"
                                      id="interselc"
                                      placeholder="Select"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div
                                class="d-flex align-items-center justify-content-between"
                              >
                                <a
                                  href="javascript:void(0);"
                                  class="text-primary d-inline-flex align-items-center add-extra fs-14 mb-3"
                                  ><i class="ti ti-circle-plus me-2"></i>Add New</a
                                >
                                <button type="button" class="btn btn-dark">
                                  <i class="ti ti-rotate-clockwise-2 me-2"></i>Generate
                                  Time Slots
                                </button>
                              </div>
                              <div class="slots-available mt-3">
                                <div
                                  class="d-flex align-items-center justify-content-between pb-3 mb-3 border-bottom"
                                >
                                  <h6 class="fs-16 fw-medium">Slot 1</h6>
                                  <a
                                    href="javascript:void(0);"
                                    class="text-danger fs-12 fw-medium rounded p-1 bg-white d-block"
                                    >Remove this Slot</a
                                  >
                                </div>
                                <div>
                                  <div class="row g-2">
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >8:30 - 9:30
                                            <span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >9:30 - 10:00
                                            <span class="d-block fs-10"
                                              >4 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >10:00 - 10:30<span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >10:00 - 10:30<span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >10:30 - 11:00
                                            <span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >11:30 - 12:00
                                            <span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >8:30 - 9:30
                                            <span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >9:30 - 10:00
                                            <span class="d-block fs-10"
                                              >4 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >10:00 - 10:30<span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >10:00 - 10:30<span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >10:30 - 11:00
                                            <span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >11:30 - 12:00
                                            <span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >8:30 - 9:30
                                            <span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >9:30 - 10:00
                                            <span class="d-block fs-10"
                                              >4 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >10:00 - 10:30<span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >10:00 - 10:30<span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >10:30 - 11:00
                                            <span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >11:30 - 12:00
                                            <span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card shadow-none rounded">
                      <div class="card-body">
                        <div class="accordion-item">
                          <div class="accordion-header" id="accordion-headingTwo">
                            <div
                              class="accordion-button p-0 border-bottom pb-3"
                              data-bs-toggle="collapse"
                              data-bs-target="#accordion-collapseTwo"
                              aria-expanded="false"
                              aria-controls="accordion-collapseTwo"
                            >
                              <h6 class="fs-16 fw-medium ms-4">Tuesday</h6>
                              <div class="form-check form-switch ms-auto">
                                <input class="form-check-input" type="checkbox" />
                              </div>
                            </div>
                          </div>
                          <div
                            id="accordion-collapseTwo"
                            class="accordion-collapse collapse"
                            aria-labelledby="accordion-headingTwo"
                            data-bs-parent="#availability_accordion"
                          >
                            <div class="accordion-body border-0 p-0 mt-3">
                              <div class="row gx-3">
                                <div class="col-md-6 col-lg">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Start Time
                                      <span class="text-danger">*</span></label
                                    >
                                    <div class="input-icon position-relative">
                                      <span class="input-icon-addon"
                                        ><i class="ti ti-clock"></i
                                      ></span>
                                      <a-time-picker
                                        v-model:value="value2"
                                        class="form-control timepicker"
                                        placeholder="Choose"
                                        use12-hours
                                        format="h:mm a"
                                        type="text"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6 col-lg">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >End Time <span class="text-danger">*</span></label
                                    >
                                    <div class="input-icon position-relative">
                                      <span class="input-icon-addon"
                                        ><i class="ti ti-clock"></i
                                      ></span>
                                      <a-time-picker
                                        v-model:value="value3"
                                        class="form-control timepicker"
                                        placeholder="Choose"
                                        use12-hours
                                        format="h:mm a"
                                        type="text"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6 col-lg">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Duration <span class="text-danger">*</span></label
                                    >
                                    <vue-select
                                      :options="SelcDuraOne"
                                      id="selcduraone"
                                      placeholder="Select"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-6 col-lg">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >No of Slots
                                      <span class="text-danger">*</span></label
                                    >
                                    <vue-select
                                      :options="SlotseclOne"
                                      id="slotseclone"
                                      placeholder="Select"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-6 col-lg">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Interval Duration
                                      <span class="text-danger">*</span></label
                                    >
                                    <vue-select
                                      :options="InterSelcOne"
                                      id="interselcone"
                                      placeholder="Select"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div
                                class="d-flex align-items-center justify-content-between"
                              >
                                <a
                                  href="javascript:void(0);"
                                  class="text-primary d-inline-flex align-items-center add-extra fs-14 mb-3"
                                  ><i class="ti ti-circle-plus me-2"></i>Add New</a
                                >
                                <button type="button" class="btn btn-dark">
                                  <i class="ti ti-rotate-clockwise-2 me-2"></i>Generate
                                  Time Slots
                                </button>
                              </div>
                              <div class="slots-available mt-3">
                                <div
                                  class="d-flex align-items-center justify-content-between pb-3 mb-3 border-bottom"
                                >
                                  <h6 class="fs-16 fw-medium">Slot 1</h6>
                                  <a
                                    href="javascript:void(0);"
                                    class="text-danger fs-12 fw-medium rounded p-1 bg-white d-block"
                                    >Remove this Slot</a
                                  >
                                </div>
                                <div>
                                  <div class="row g-2">
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment2"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >8:30 - 9:30
                                            <span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment2"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >9:30 - 10:00
                                            <span class="d-block fs-10"
                                              >4 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment2"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >10:00 - 10:30<span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment2"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >10:00 - 10:30<span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment2"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >10:30 - 11:00
                                            <span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment2"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >11:30 - 12:00
                                            <span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment2"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >8:30 - 9:30
                                            <span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment2"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >9:30 - 10:00
                                            <span class="d-block fs-10"
                                              >4 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment2"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >10:00 - 10:30<span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment2"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >10:00 - 10:30<span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment2"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >10:30 - 11:00
                                            <span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment2"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >11:30 - 12:00
                                            <span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment2"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >8:30 - 9:30
                                            <span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment2"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >9:30 - 10:00
                                            <span class="d-block fs-10"
                                              >4 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment2"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >10:00 - 10:30<span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >10:00 - 10:30<span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >10:30 - 11:00
                                            <span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-sm-6">
                                      <div
                                        class="form-check-inline visits w-100 p-0 me-0"
                                      >
                                        <label class="visit-btns">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            name="appointment"
                                          />
                                          <span class="visit-rsn fs-12 bg-white"
                                            >11:30 - 12:00
                                            <span class="d-block fs-10"
                                              >2 Slots</span
                                            ></span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex justify-content-end align-items-center mt-3 pt-3 border-top"
                >
                  <button class="btn btn-dark next_btn" type="button" @click="nextStep">
                    Save & Continue
                  </button>
                </div>
              </fieldset>
              <fieldset
                v-if="currentStep === 1"
                :style="{ display: currentStep === 1 ? 'flex' : 'none' }"
              >
                <div class="accordion">
                  <form @submit.prevent="submitForm">
                    <div class="card shadow-none rounded">
                      <div class="card-body pb-0">
                        <div class="accordion-item">
                          <div class="accordion-header" id="accordion2-headingOne">
                            <div
                              class="accordion-button p-0 border-bottom pb-3"
                              data-bs-toggle="collapse"
                              data-bs-target="#accordion2-collapseOne"
                              aria-expanded="true"
                              aria-controls="accordion2-collapseOne"
                            >
                              <h6 class="fs-16 fw-medium ms-4">All Days</h6>
                              <div class="form-check form-switch ms-auto">
                                <input class="form-check-input" type="checkbox" />
                              </div>
                            </div>
                          </div>
                          <div
                            id="accordion2-collapseOne"
                            class="accordion-collapse collapse show"
                            aria-labelledby="accordion2-headingOne"
                            data-bs-parent="#availability_accordion2"
                          >
                            <div class="accordion-body border-0 p-0 mt-3">
                              <div class="row">
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label class="form-label">Morning Break</label>
                                    <div class="sel-cal Calendar-icon">
                                      <span><i class="ti ti-clock"></i></span>
                                      <a-time-picker
                                        v-model:value="value4"
                                        class="form-control timepicker"
                                        placeholder="Choose"
                                        use12-hours
                                        format="h:mm a"
                                        type="text"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label class="form-label">Lunch</label>
                                    <div class="sel-cal Calendar-icon">
                                      <span><i class="ti ti-clock"></i></span>
                                      <a-time-picker
                                        v-model:value="value5"
                                        class="form-control timepicker"
                                        placeholder="Choose"
                                        use12-hours
                                        format="h:mm a"
                                        type="text"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label class="form-label">Evening Break</label>
                                    <div class="sel-cal Calendar-icon">
                                      <span><i class="ti ti-clock"></i></span>
                                      <a-time-picker
                                        v-model:value="value6"
                                        class="form-control timepicker"
                                        placeholder="Choose"
                                        use12-hours
                                        format="h:mm a"
                                        type="text"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card shadow-none rounded">
                      <div class="card-body pb-0">
                        <div class="accordion-item">
                          <div class="accordion-header" id="accordion2-headingTwo">
                            <div
                              class="accordion-button p-0 border-bottom pb-3"
                              data-bs-toggle="collapse"
                              data-bs-target="#accordion2-collapseTwo"
                              aria-expanded="false"
                              aria-controls="accordion2-collapseTwo"
                            >
                              <h6 class="fs-16 fw-medium ms-4">Monday</h6>
                              <div class="form-check form-switch ms-auto">
                                <input class="form-check-input" type="checkbox" />
                              </div>
                            </div>
                          </div>
                          <div
                            id="accordion2-collapseTwo"
                            class="accordion-collapse collapse"
                            aria-labelledby="accordion2-headingTwo"
                            data-bs-parent="#availability_accordion2"
                          >
                            <div class="accordion-body border-0 p-0 mt-3">
                              <div class="row">
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label class="form-label">Morning Break</label>
                                    <div class="sel-cal Calendar-icon">
                                      <span><i class="ti ti-clock"></i></span>
                                      <a-time-picker
                                        v-model:value="value8"
                                        class="form-control timepicker"
                                        placeholder="Choose"
                                        use12-hours
                                        format="h:mm a"
                                        type="text"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label class="form-label">Lunch</label>
                                    <div class="sel-cal Calendar-icon">
                                      <span><i class="ti ti-clock"></i></span>
                                      <a-time-picker
                                        v-model:value="value7"
                                        class="form-control timepicker"
                                        placeholder="Choose"
                                        use12-hours
                                        format="h:mm a"
                                        type="text"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label class="form-label">Evening Break</label>
                                    <div class="sel-cal Calendar-icon">
                                      <span><i class="ti ti-clock"></i></span>
                                      <a-time-picker
                                        v-model:value="value9"
                                        class="form-control timepicker"
                                        placeholder="Choose"
                                        use12-hours
                                        format="h:mm a"
                                        type="text"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div
                  class="d-flex justify-content-end align-items-center mt-3 pt-3 border-top"
                >
                  <a
                    href="javascript:void(0);"
                    class="btn btn-light prev_btn me-2"
                    v-if="currentStep > 0"
                    @click="prevStep"
                    >Back</a
                  >
                  <button class="btn btn-dark next_btn" @click="nextStep">
                    Save & Continue
                  </button>
                </div>
              </fieldset>
              <fieldset
                v-if="currentStep === 2"
                :style="{ display: currentStep === 2 ? 'flex' : 'none' }"
              >
                <form action="#">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="mb-3">
                        <label class="form-label"
                          >Stat Date & End Date <span class="text-danger"> *</span></label
                        >
                        <div class="sel-cal Calendar-icon">
                          <span><i class="ti ti-calendar"></i></span>
                          <a-time-picker
                            v-model:value="value10"
                            class="form-control timepicker"
                            placeholder="Choose"
                            use12-hours
                            format="h:mm a"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="mb-0">
                        <h6 class="fw-medium fs-16 mb-2">Unavailable days</h6>
                        <div
                          class="d-flex align-items-center justify-content-between border rounded p-2 bg-light-300"
                        >
                          <div>
                            <span class="fs-14 d-block mb-1">Unavailable on</span>
                            <p class="fs-14 fw-medium">Sep 15 2024, Wednesday</p>
                          </div>

                          <span class="badge badge-success">Upcoming</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
                <div
                  class="d-flex justify-content-end align-items-center mt-3 pt-3 border-top"
                >
                  <a
                    href="javascript:void(0);"
                    class="btn btn-light prev_btn me-2"
                    v-if="currentStep > 1"
                    @click="prevStep"
                    >Back</a
                  >
                  <button
                    class="btn btn-dark"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#successmodal"
                  >
                    Save & Continue
                  </button>
                </div>
              </fieldset>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Availability -->

  <!-- Delete Account -->
  <div class="modal fade custom-modal" id="del-account">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Delete Account</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form action="#">
          <div class="modal-body">
            <p class="mb-3">
              Are you sure you want to delete This Account? To delete your account, Type
              your password.
            </p>
            <div class="mb-0">
              <label class="form-label">Password</label>
              <div class="pass-group">
                <input
                  :type="isPasswordVisible ? 'text' : 'password'"
                  class="form-control pass-input"
                  placeholder="*************"
                />
                <span
                  @click="togglePasswordVisibility"
                  :class="
                    isPasswordVisible
                      ? 'toggle-password feather-eye'
                      : 'toggle-password feather-eye-off'
                  "
                ></span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">
              Delete Account
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Delete Account -->

  <!-- Modal Succss -->
  <div class="modal fade service-models" id="successmodal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center py-4">
            <span class="success-check mb-3 mx-auto"><i class="ti ti-check"></i></span>
            <h4 class="mb-2">Availability Created Successfully</h4>
            <p>
              Availability for “Electrical Services” has been Created, and updated on your
              List
            </p>
            <div class="f-flex align-items-center justify-content-center mt-3">
              <a
                href="javascript:void(0);"
                class="btn btn-light me-3"
                data-bs-dismiss="modal"
                >Close</a
              >
              <router-link to="/provider/staff-list" class="btn btn-dark" data-bs-dismiss="modal"
                >Go to List</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal Succss -->
</template>
